import type { FeatureFlag } from '@swf/core/enums';
import type { RootState, SelectorCreator, Slicer } from '@swf/core/store';

import type { FeatureState } from './index';

const selectors = (slice: Slicer<FeatureState>, createSelector: SelectorCreator) => ({
  get() {
    return slice;
  },
  check() {
    return createSelector(
      slice,
      (rootState: RootState, feature: FeatureFlag) => feature,
      (state, feature) => !!state[feature]
    );
  },
  list() {
    return slice((state) => Object.keys(state) as FeatureFlag[]);
  }
});

export default selectors;
